<template>
    <div class="filters">
        <filter-item :title="filter.filtergroup" :is-open-default="filter.open" v-for="(filter,key) in filterz" :key="key">
            <div v-for="(filters, key) in filter.filters" :key="key">
                <div class="e-checks grey line-bottom" v-if="filters.type === 'checkbox'">
                    <checkbox v-for="(options, key) in filters.options" :group="filters.group" :filtergroup="filter.filtergroup" :name="options.value" :checked="options.checked" :type="options.value" :key="key" :filter-id="filters.filterId"></checkbox>
                </div>
                <div class="e-checks grey line-bottom" v-if="filters.type === 'radio'">
                    <radio class="e-info-radios" :filter-id="filters.filterId" :name="filters.group" :data="filters.options"></radio>
                </div>
                <template v-if="filters.type === 'between'" v-for="(options, key) in filters.options">
                    <span>{{ $t(options.value)}}</span>
                    <div>&nbsp;</div>
                    <between :filter-id="filters.filterId" :active-filters="activeFilters" class="line-bottom grey" separator-value="tot" :key="key" :group="filters.group" :filtergroup="filter.filtergroup" :value="options.value" :from-value="options.min" :to-value="options.max" measurement-type="width"></between>
                </template>
                <template v-if="filters.type === 'singleInput'" v-for="(options, key) in filters.options">
                    <div class="line-bottom">
                        <div>
                            <span>{{ $t(options.value)}}</span>
                            <div>&nbsp;</div>
                            <div class="row">
                                <basic-input class="col-6 grey" :group="filters.group" :filtergroup="filter.filtergroup" :value="options.value" :input="options.input" :filter-id="filters.filterId"></basic-input>
                            </div>
                        </div>
                    </div>
                </template>
                <template v-if="filters.type === 'multicheck'">
                    <span>{{ $t(filters.group)}}</span>
                     <div>&nbsp;</div>
                    <div class="e-checks grey line-bottom">
                        <checkbox v-for="(options, key) in filters.options" :group="filters.group" :filtergroup="filter.filtergroup" :name="options.value" :checked="options.checked" :type="options.value" :key="key" :filter-id="filters.filterId"></checkbox>
                        <!--<square-checkbox :name="filters.group" :group="filters.group" :filtergroup="filter.filtergroup" :value="options.value" v-for="(options, key) in filters.options" :key="key" :filter-id="filters.filterId"></square-checkbox>-->
                    </div>
                </template>
                <template v-if="filters.type === 'selector'" v-for="(options,key) in filters.options">
                    <span>{{ $t(options.value)}}</span>
                    <dropdown :options="options.selects" :group="filters.group" :filtergroup="filter.filtergroup" :value="options.value" :filter-id="filters.filterId" class="line-bottom green"></dropdown>
                </template>
                <template v-if="filters.type === 'multiInput'">
                    <div class="row line-bottom">
                        <div class="col-6" v-for="(options, key) in filters.options">
                            <span>{{ $t(options.value) }}</span>
                            <div>&nbsp;</div>
                            <basic-input class="grey" :group="filters.group" :filtergroup="filter.filtergroup" :value="options.value" :input="options.input" :filter-id="options.filterId"></basic-input>
                        </div>
                    </div>
                </template>
            </div>
        </filter-item>
    </div>
</template>

<script>
    import Checkbox from '../elements/CheckboxFilter'
    import Radio from '../elements/RadiosFilter'
    import SquareCheckbox from '../elements/SquareCheckbox'
    import Between from '../elements/Between'
    import BasicInput from '../elements/BasicInput';
    import Filter from '../elements/Filter';
    import Dropdown from '../elements/Dropdown';
    export default {
        data () {
          return {
          }
        },
        name: 'Filters',
        props: {
            filterz: {
                required: true,
                type: Object
            },
            activeFilters: Array,
        },
        components: {
          'checkbox': Checkbox,
          'square-checkbox': SquareCheckbox,
          'between': Between,
          'basic-input': BasicInput,
          'filter-item': Filter,
          'dropdown': Dropdown,
          'radio': Radio
        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/elements/Filters.vue